module.exports = __webpack_public_path__ + "static/media/new2.e53526a9.jpg";